import { Controller } from "stimulus"
import { Modal } from 'bootstrap'

export default class extends Controller {
  connect() {
    const modal = new Modal(this.element)
    modal.show()
  }
}